import { ThunkDispatch } from "core-integration/src/store";
import { getElementTypes } from "core-integration/src/store/element-types/reducers";
import { getElements } from "core-integration/src/store/elements/reducers";
import { showElementSummary } from "core-integration/src/store/elements/thunks";
import { IElement } from "core-integration/src/store/elements/types";
import { getTeamsById } from "core-integration/src/store/teams/reducers";
import { ITeam } from "core-integration/src/store/teams/types";
import { useTranslation } from "react-i18next";
import { useDispatch, useSelector } from "react-redux";
import BoldLink from "../../BoldLink";
import ElementInTable from "../../ElementInTable";
import { ElementRow } from "../../ElementTable";
import SubHeading from "../../SubHeading";
import StatusPanel from "../StatusPanel";
import {
  GroupHeading,
  MoreLinkWrap,
  PlayerCell,
  PlayersTable,
  RightCell,
} from "../styles";

const playersPerPosition = 5;

const MostSelectedPlayersTable = () => {
  const elements = useSelector(getElements);
  const elementTypes = useSelector(getElementTypes);
  const dispatch = useDispatch<ThunkDispatch>();
  const teamsById = useSelector(getTeamsById);
  const { t } = useTranslation();

  const showElementDialog = (element: IElement) =>
    dispatch(showElementSummary(element.id));

  return (
    <StatusPanel>
      <StatusPanel.Header>
        <SubHeading>
          {t("status.mostSelectedPlayers", "Most Selected Players")}
        </SubHeading>
      </StatusPanel.Header>
      <StatusPanel.Body>
        {elementTypes.map((elementType) => {
          const positionElements = elements
            .filter((element) => element.element_type === elementType.id)
            .sort(
              (a, b) =>
                Number(b.selected_by_percent) - Number(a.selected_by_percent),
            )
            .slice(0, playersPerPosition);

          if (!positionElements.length) {
            return null;
          }

          return (
            <PlayersTable key={elementType.id}>
              <thead>
                <tr>
                  <GroupHeading colSpan={2}>
                    {elementType.plural_name}
                  </GroupHeading>
                </tr>
              </thead>
              <tbody>
                {positionElements.map((element) => {
                  const team = teamsById[element.team] as ITeam;

                  return (
                    <ElementRow key={element.id}>
                      <PlayerCell>
                        <ElementInTable
                          element={element}
                          renderElementMenu={() => showElementDialog(element)}
                          team={team}
                        />
                      </PlayerCell>
                      <RightCell>{element.selected_by_percent}%</RightCell>
                    </ElementRow>
                  );
                })}
              </tbody>
            </PlayersTable>
          );
        })}
        <MoreLinkWrap>
          <BoldLink to="/statistics/selected_by_percent">
            {t("status.viewMore", "View more")}
          </BoldLink>
        </MoreLinkWrap>
      </StatusPanel.Body>
    </StatusPanel>
  );
};

export default MostSelectedPlayersTable;
